import { render, staticRenderFns } from "./BottomMenu.vue?vue&type=template&id=b407e51e&scoped=true&"
import script from "./BottomMenu.vue?vue&type=script&lang=ts&"
export * from "./BottomMenu.vue?vue&type=script&lang=ts&"
import style0 from "./BottomMenu.vue?vue&type=style&index=0&id=b407e51e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b407e51e",
  null
  
)

export default component.exports